import { Divider, List, ListItem, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import {
  spacing,
  typography,
  colors,
} from "../../../../../../../../../assets/styles/tokens";

interface BudgetControlCardItemMoreMetricsProps {
  remaining_qftd: string;
  cpa_income_dollar: string;
  total_income_dollar: string;
  cpa_budget_dollar: string;
  ftd: string;
}

const BudgetControlCardItemMoreMetrics = ({
  remaining_qftd,
  cpa_income_dollar,
  total_income_dollar,
  cpa_budget_dollar,
  ftd,
}: BudgetControlCardItemMoreMetricsProps) => {
  return (
    <>
      <Stack>
        <List sx={{ pb: 0, color: colors.GrayLightMode[900].$value }}>
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              REMAINING QFTD
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.xs.$value,
                }}
              >
                {remaining_qftd}
              </Box>
            </Typography>
          </ListItem>
          <Divider />
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
             CPA INCOME
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.xs.$value,
                }}
              >
                {cpa_income_dollar}
              </Box>
            </Typography>
          </ListItem>
          <Divider />
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              TOTAL INCOME
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.xs.$value,
                }}
              >
                {total_income_dollar}
              </Box>
            </Typography>
          </ListItem>
          <Divider />
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
             CPA BUDGET
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.xs.$value,
                }}
              >
                {cpa_budget_dollar}
              </Box>
            </Typography>
          </ListItem>
          <Divider />
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              FTD
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.xs.$value,
                }}
              >
                {ftd}
              </Box>
            </Typography>
          </ListItem>
          
        </List>
      </Stack>
    </>
  );
};

export default BudgetControlCardItemMoreMetrics;
